/* LEVATA — buy box behaviour.
   Progressive enhancement: with JS off, the form posts to /cart/add and the
   sale still completes. With JS on we skip the cart page entirely — the only
   reason a cart step would exist (the add-ons) is handled on this screen. */
(function () {
  'use strict';

  var root = document.querySelector('[data-lv-buybox]');
  if (!root) return;

  var form      = root.querySelector('form[action*="/cart/add"]');
  var idField   = root.querySelector('[data-lv-id]');
  var tiers     = Array.prototype.slice.call(root.querySelectorAll('[data-lv-tier]'));
  var addons    = Array.prototype.slice.call(root.querySelectorAll('[data-lv-addon]'));
  var ctaPrice  = root.querySelector('[data-lv-cta-price]');
  var submitBtn = root.querySelector('[data-lv-submit]');
  var sticky    = root.querySelector('[data-lv-sticky]');
  var stickyBtn = root.querySelector('[data-lv-sticky-btn]');
  var stickyName= root.querySelector('[data-lv-sticky-name]');
  var stickyPr  = root.querySelector('[data-lv-sticky-price]');

  var cfg = window.LEVATA || {};
  var fmt;
  try {
    // Deliberately not cfg.locale: the storefront's own locale is not the buyer's.
    // With the shop defaulting to French this rendered the sticky-bar total as
    // "198,00 $US" under American English copy. Prices here are USD to a US
    // market, so the money formats as en-US regardless of storefront language.
    fmt = new Intl.NumberFormat('en-US', {
      style: 'currency', currency: cfg.currency || 'USD',
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  } catch (e) {
    fmt = { format: function (n) { return '$' + n.toFixed(2); } };
  }
  function money(cents) {
    var s = fmt.format(cents / 100);
    return s.replace(/([.,])00$/, '');   /* $129.00 -> $129, keeps $4.95 */
  }

  /* ---------- state ---------- */
  function currentTier() {
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].querySelector('input').checked) return tiers[i];
    }
    return tiers[0];
  }

  function total() {
    var sum = 0;
    var t = currentTier();
    if (t) sum += parseInt(t.getAttribute('data-cents'), 10) || 0;
    addons.forEach(function (a) {
      if (a.querySelector('input').checked) {
        sum += parseInt(a.getAttribute('data-cents'), 10) || 0;
      }
    });
    return sum;
  }

  function paint() {
    var t = currentTier();
    if (!t) return;
    tiers.forEach(function (el) { el.classList.toggle('lv-tier--on', el === t); });
    addons.forEach(function (el) {
      el.classList.toggle('lv-addon--on', el.querySelector('input').checked);
    });
    if (idField) idField.value = t.getAttribute('data-variant');
    var sum = total();
    if (ctaPrice) ctaPrice.textContent = money(sum);
    if (stickyPr) stickyPr.textContent = money(sum);
    if (stickyName) stickyName.textContent = t.getAttribute('data-name') || '';
  }

  tiers.forEach(function (el) {
    el.addEventListener('change', paint);
  });
  addons.forEach(function (el) {
    el.addEventListener('change', paint);
  });
  paint();

  /* ---------- checkout ---------- */
  var busy = false;
  var busyEl = null;
  var restLabel = '';
  var waitLabel = (submitBtn && submitBtn.getAttribute('data-lv-wait')) || 'One moment…';

  /* One place that switches the buy box between "ready" and "leaving for the
     checkout". It has to be reversible: iOS Safari restores this page from
     the back-forward cache when the buyer taps Back from the checkout, with
     the DOM exactly as it was left — "One moment…" on the button and every
     wallet ignored because `busy` was still true. */
  function setBusy(on, el) {
    busy = on;
    if (submitBtn) {
      if (on) {
        restLabel = submitBtn.innerHTML;
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<span>' + waitLabel + '</span>';
      } else if (restLabel) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = restLabel;
        restLabel = '';
        ctaPrice = root.querySelector('[data-lv-cta-price]');   /* innerHTML rebuilt the node */
        paint();
      }
    }
    if (stickyBtn) stickyBtn.disabled = on;
    if (busyEl) busyEl.classList.remove('lv-wallet--busy');
    busyEl = (on && el && el.classList && el.classList.contains('lv-wallet')) ? el : null;
    if (busyEl) busyEl.classList.add('lv-wallet--busy');
  }
  window.addEventListener('pageshow', function () { setBusy(false); });
  window.addEventListener('pagehide', function () { setBusy(false); });

  function lineItems() {
    var items = [];
    var t = currentTier();
    if (t) items.push({ id: Number(t.getAttribute('data-variant')), quantity: 1 });
    addons.forEach(function (a) {
      if (a.querySelector('input').checked) {
        items.push({ id: Number(a.getAttribute('data-variant')), quantity: 1 });
      }
    });
    return items;
  }

  function go(e, wallet) {
    if (e) e.preventDefault();
    if (busy) return;
    setBusy(true, e && e.currentTarget);
    var items = lineItems();

    /* Shop Pay: the cart permalink with payment=shop_pay hands the buyer to
       Shop Pay's own flow (Shopify docs, "Create cart permalinks", step 9:
       "Send buyers into Shop Pay"). The account is recognised and the
       address and card are pre-filled — a plain /checkout would only show
       the Shop Pay button among the express options. */
    if (wallet === 'shop_pay') {
      window.location.href = '/cart/' + items.map(function (i) { return i.id + ':' + i.quantity; }).join(',') + '?payment=shop_pay';
      return;
    }

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/clear.js' : '/cart/clear.js',
          { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      })
      .catch(function () {
        /* never strand the buyer: fall back to the ordinary form post */
        setBusy(false);
        if (form) form.submit();
      });
  }

  if (form) form.addEventListener('submit', go);
  if (stickyBtn) stickyBtn.addEventListener('click', go);
  /* wallet row: Shop Pay takes its own route (above); Apple Pay, PayPal and
     Card go to the checkout with the tier in the cart */
  Array.prototype.slice.call(root.querySelectorAll('[data-lv-go]')).forEach(function (b) {
    b.addEventListener('click', function (e) { go(e, b.getAttribute('data-lv-go')); });
  });

  /* repeated offer further down the page: one tap sets the tier and checks out */
  Array.prototype.slice.call(document.querySelectorAll('[data-lv-pick]')).forEach(function (pick) {
    pick.addEventListener('click', function () {
      var want = pick.getAttribute('data-variant');
      tiers.forEach(function (t) {
        if (t.getAttribute('data-variant') === want) t.querySelector('input').checked = true;
      });
      paint();
      go();
    });
  });

  /* ---------- sticky bar: appear once the real button is gone ---------- */
  if (sticky && submitBtn && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      sticky.classList.toggle('lv-sticky--on', !visible);
    }, { rootMargin: '0px 0px -40px 0px' });
    io.observe(submitBtn);
  }

  /* ---------- gallery ---------- */
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-lv-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lv-thumb]'));
  function show(i) {
    slides.forEach(function (s) {
      var on = s.getAttribute('data-lv-slide') === String(i);
      s.classList.toggle('lv-gal__slide--on', on);
      if (s.tagName === 'VIDEO') {
        if (on) { s.preload = 'auto'; var pr = s.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else { s.pause(); }
      }
    });
    thumbs.forEach(function (t) {
      var on = t.getAttribute('data-lv-thumb') === String(i);
      t.classList.toggle('lv-gal__thumb--on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { show(t.getAttribute('data-lv-thumb')); });
  });

  /* swipe on the main image */
  var main = root.querySelector('.lv-gal__main');
  if (main && thumbs.length > 1) {
    var x0 = null, idx = 0;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) {
        idx = Math.min(Math.max(idx + (dx < 0 ? 1 : -1), 0), thumbs.length - 1);
        show(idx);
      }
      x0 = null;
    }, { passive: true });
  }
})();
